import {
  type Device,
  type DeviceEvent,
  type DeviceEventName,
  type DeviceEventProperties,
} from '../types/deviceEvents.type';

export const buildDeviceEventPayload = <D extends Device, E extends DeviceEventName<D>>(
  device: D,
  name: E,
  properties?: DeviceEventProperties<D, E>,
): DeviceEvent => {
  const event = `device.${device}.${name}` as DeviceEvent['event'];
  const timestamp = Date.now();

  if (properties === undefined) return { event, timestamp } as DeviceEvent;

  return { event, properties, timestamp } as DeviceEvent;
};
